const maxDecimals = 2

function formatAmount (amount) {
  return Number(Math.round(parseFloat(amount + 'e' + maxDecimals)) + 'e-' + maxDecimals).toFixed(maxDecimals)
}

export {
  formatAmount,
}
